import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { AuthService } from '../utilities/auth/auth.service';
import { Role } from '../models/auth/role';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-un-authorized',
  templateUrl: './un-authorized.component.html',
  styleUrls: ['./un-authorized.component.scss']
})
export class UnAuthorizedComponent {

  constructor(
    private msalService: MsalService,
    private router: Router,
    private authService: AuthService
  ) {

  }

  loginRedirect() {
    const accessTokenRequest = {
      scopes: [environment.b2cConfig.clientId],
      account: this.msalService.instance?.getAllAccounts()[0],
      forceRefresh: true
    };
    this.msalService.ssoSilent(accessTokenRequest).subscribe({
      next: (data) => {
        this.handleTokenResponse(data);
      },
      error: (error) => {
        this.msalService.acquireTokenPopup(accessTokenRequest).subscribe((response) => {
          this.handleTokenResponse(response);
        })
      }
    });

  }
  
  handleTokenResponse(response) {
    if (response?.account?.idTokenClaims!['userRole']) {
      this.authService.userValue.userRole = response.account.idTokenClaims!['userRole'] as Role;
      this.authService.emitRoleUpdate();
      this.router.navigateByUrl("/");
    }
  }
}